import translate from './i18n';
import TitleComponent from '../TitleComponent/index.vue';
import VueOrder from '../../../_Order/index.vue';
import VueOrderComment from '../../../_OrderComment/index.vue';
import conversionPaidCheckGTM from '../../../../../mixins/conversionPaidCheckGTM';
import { INSPECTION_CENTER_STATION_ID } from '../../../../../../constants/autotest';

export default {
  mixins: [conversionPaidCheckGTM],

  props: {
    advertisementsData: {
      type: Object,
      default: () => {},
    },
    price: {
      type: Number,
      default: 0,
    },
  },
  components: {
    TitleComponent,
    VueOrder,
    VueOrderComment,
  },
  data() {
    return ({
      dataChecks: {
        list: [
          {
            name: 'Вид звіту',
            link: {
              href: '/vue/technicalcheck/248622/?hash=MTcxNTk5NzYzODgzMA==',
              text: 'Приклад звіту',
              icon: 'i16_link',
            },
          },
          {
            name: 'Компютерна діагностика',
          },
          {
            name: 'Поверхневий огляд двигуна',
          },
          {
            name: 'Перевірка кузова',
          },
          {
            name: 'Огляд салону',
          },
          {
            name: 'Перевірка світлових приладів',
          },
          {
            name: 'Огляд шин та дисків',
          },
          {
            name: 'Фото та відеозвіт',
          },
        ],
        price: 1800,
      },

      state: 'commenting',
      offer: null,
      orderPayload: null,
      user: null,
      comment: '',
      orderResponse: {},

      loading: false,
    });
  },
  computed: {
    ordersId() {
      const { orderResponse: { orders: { technical: { id } = {} } = {} } = {} } = this;
      return id;
    },
    orderPayloadData() {
      return {
        advertisementId: this.advertisementsData?.id,
        user: this.user,
        orderData: {
          technical: {
            cityId: Number(this.advertisementsData?.location?.city?.id),
            price: this.price,
            type: 'technical',
            stoId: INSPECTION_CENTER_STATION_ID,
            sto: {
              stoId: INSPECTION_CENTER_STATION_ID,
            },
          },
        },
        message: this.comment,
      };
    },
  },

  methods: {
    onOrdered(payload) {
      this.orderResponse = { ...payload };

      this.state = 'ordered';
      const { orderResponse: { orders: { technical: { id } = {} } = {} } = {} } = this;
      this.$emit('handleClick', { name: 'ConfirmationMessage', id });
    },

    onCommented(payload = {}) {
      this.loading = true;
      const { user, comment } = payload;
      this.user = user;
      this.comment = comment;
      this.state = 'ordering';
      this.loading = false;
    },
  },
  i18n: {
    ...translate,
  },
};
